module.exports = __webpack_public_path__ + "img/1080_01.391864bb.jpg";